import { navigate } from "raviger";

import useStore from "core/custom-hooks/useStore";

import { resetStore } from "core/store/actionCreators";
import { removeToken } from "repositories/clients/rest";
import {
    GRECAPTCHA_STORAGE_KEY,
    ACCESS_TOKEN_LOCAL_STORAGE_KEY,
    REFRESH_TOKEN_LOCAL_STORAGE_KEY,
    RETURN_PATH_LOCAL_STORAGE_KEY,
    SUBBUSINESS_ID_LOCAL_STORAGE_KEY,
    CONFIG_STORAGE_KEY
} from "core/common/constants/localstorage";

const useLogout = () => {
    const { dispatch, logoutRepository } = useStore();

    const handleLogout = () => {

        const logout = async () => {

            const rt = localStorage.getItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY);

            if (rt) {
                await logoutRepository.logout(rt);
            }
            localStorage.removeItem(GRECAPTCHA_STORAGE_KEY);

            sessionStorage.removeItem(ACCESS_TOKEN_LOCAL_STORAGE_KEY);

            localStorage.removeItem(REFRESH_TOKEN_LOCAL_STORAGE_KEY);
            localStorage.removeItem(RETURN_PATH_LOCAL_STORAGE_KEY);
            localStorage.removeItem(SUBBUSINESS_ID_LOCAL_STORAGE_KEY);
            localStorage.removeItem(CONFIG_STORAGE_KEY);
            removeToken();
            dispatch(resetStore());
            navigate("/login");
        }

        logout();
    };

    return { handleLogout };
};

export default useLogout;
